module.exports = __webpack_public_path__ + "img/ru.3fbd146a.png";